import { render, staticRenderFns } from "./CoreProgramCampaignCreate.vue?vue&type=template&id=6ef0614a&"
import script from "./CoreProgramCampaignCreate.vue?vue&type=script&lang=js&"
export * from "./CoreProgramCampaignCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports